// extracted by mini-css-extract-plugin
module.exports = {"mask":"Background_mask__niEBy","gradient":"Background_gradient__7xPCl","lines":"Background_lines__jASbR","dots":"Background_dots__lE6Uv"};